function stripSearchParams(path: string): string {
  if (path.indexOf('?') > -1) {
    return path.substr(0, path.indexOf('?'));
  }

  return path;
}

function getPathSegments(path: string): Array<string> {
  return stripSearchParams(path).replace(/\/$/, '').split('/');
}

export function matchPathAndRoute(path: string, route: string): boolean {
  const pathArray = getPathSegments(path);
  const routeArray = getPathSegments(route);

  if (pathArray.length !== routeArray.length) {
    // It could be possible that we have a path like `/sites/:siteId/feedback/create/:copyId` where the `copyId` param
    // is optional (this matches how angular handles the routing). So we need to pop off any optional trailing
    // path params and then re-check the length and decide from there if we want to recheck the routes.
    let routeArrayIndex = routeArray.length - 1;

    while (routeArrayIndex > -1) {
      if (!routeArray[routeArrayIndex].startsWith(':')) {
        break;
      } else {
        routeArray.pop();
      }

      routeArrayIndex -= 1;
    }

    if (pathArray.length !== routeArray.length) {
      return false;
    }
  }

  return routeArray.every((segment, index) => {
    if (!segment.startsWith(':') && pathArray[index] !== segment) {
      return false;
    }

    return true;
  });
}
